import React, { ReactElement } from 'react';
import OrderItemDevice from './items/OrderItemDevice';
import OrderItemSimOnly from './items/OrderItemSimOnly';
import Button from '../../buttons/Button';
import './scss/orderItemsSection.scss';

interface Props {
  orderItem: any;
  cancelUrl: string;
  labelButton: string;
  labelWithTariffPackage: string;
  labelSimOnlyCard: string;
  buttonStyle: string;
  handleOnClick: () => void;
}

const OrderItemSection: React.FC<Props> = (props: Props): ReactElement => {
  const {
    labelButton,
    buttonStyle,
    orderItem,
    labelWithTariffPackage,
    labelSimOnlyCard,
    handleOnClick,
  } = props;

  return (
    <React.Fragment>
      {orderItem.device ?
        <OrderItemDevice
          orderItem={orderItem}
          labelWithTariffPackage={labelWithTariffPackage}
        /> :
        <OrderItemSimOnly
          orderItem={orderItem}
          labelWithTariffPackage={labelWithTariffPackage}
          labelSimOnlyCard={labelSimOnlyCard}
        />
      }
      <div className={'button-container d-block'}>
        <Button
          onClick={handleOnClick}
          type='button'
          style={buttonStyle}
        >
          <span className={'fw-bold'}>{labelButton}</span>
        </Button>
      </div>
    </React.Fragment>
  );
};

export default OrderItemSection;
